import React, { useEffect, useState } from 'react'
import styles from './style/outlet_section_style.module.scss'
import Typography from '../../design-system/foundations/typography/Typography'
import Carousel from '../../design-system/basics/carousel/Carousel'
import OutletProductCard from '../../design-system/moleculars/outlet-product-card/OutletProductCard'
import Button from '../../design-system/basics/button/Button'
import Translation from '../../global/Translation'
import LocalizedLink from '../../global/LocalizedLink'
import PnSpinner from '../PnSpinner'

const OutletSection = (props) => {
    const [outletProducts, setOutletProducts] = useState(null)

    useEffect(() => {
        props.fetchOutlet()
    }, [])

    useEffect(() => {
        if (props.outletProducts && props.outletProducts.length > 0) {
            setOutletProducts(props.outletProducts)
        }
    },[props.outletProducts])

    useEffect(() => {
        return props.updateSection && props.updateSection(props.id, outletProducts)
    }, [outletProducts])

    return (
        <div className={styles['outlet-section']}>
            <div className={styles['outlet-section-header']}>
                <Typography className={styles['outlet-section-title']} typeface="title-xl-light">
                    <Translation id="natural_stone_outlet" defaultMessage="NATURAL STONE OUTLET"/>
                </Typography>

                <LocalizedLink routeId='ROUTE_CATALOG'
                               queryString='?brand[0]=SCALEA&brand[1]=SENSA&type[0]=SLAB'
                               params={{'outlet': 'hqoutlet'}}
                >
                    <Button style-link
                            size-m
                            onClick={() => {}}
                            img={props.languageDir === 'rtl' ? "arrow_short_inverse" : "arrow_short"}
                            hImg={props.languageDir === 'rtl' ? "arrow_large_inverse" : "arrow_large"}
                            gtmLabel="item-list_button_view-all-natural-stone-outlet"
                    >
                        <Translation id="view_all_natural_stone_outlet" defaultMessage="View all Natural Stone Outlet"/>
                    </Button>
                </LocalizedLink>
            </div>

            {props.loadingOutletProduct && <PnSpinner />}

            {outletProducts &&
                <div id={props.id} className={styles['outlet-section-carousel']}>
                    <Carousel minItemSize={280}
                              section={'OUTLET'}
                              items={outletProducts.map((product, index) => <OutletProductCard
                                  product={product}
                                  centerId={props.centerId}
                                  index={index}
                                  list='PN-OUTLET'
                              />)}
                    />
                </div>
            }
        </div>
    )
};

OutletSection.propTypes = {
}

export default OutletSection;